import { LazyImage } from "@blackjackfun/ui-components"
import { assetUrl, assetSrcSet } from "./WebpLazyImage.utils";
import { LazyImageProps } from "./WebpLazyImage.types";

export const WebpLazyImage: React.FC<LazyImageProps> = (props) => {
    const src = props.src;
    const preparedSrc = assetUrl(src);
    const preparedSrcSet = assetSrcSet(props);

    return (
        <LazyImage 
            {...props}
            src={preparedSrc} 
            srcSet={preparedSrcSet}
        />
    )   
}